import { Component, Inject, OnInit } from '@angular/core';
import { PrintGSTReportComponent } from '../print-gstreport/print-gstreport.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-vatnaval-distribution',
  // standalone: true,
  // imports: [],
  templateUrl: './vatnaval-distribution.component.html',
  styleUrl: './vatnaval-distribution.component.scss'
})
export class VatnavalDistributionComponent implements OnInit {

  startDate = '';
  endDate = '';
  sundayDates: string[] = [];
  today: any;

  yourData: any[] = [];


  constructor(
    private dialogref: MatDialogRef<PrintGSTReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {
    this.today = formatDate(new Date(), 'yyyy/MM/dd', 'en-IN', 'GMT+0530');
  }

  ngOnInit(): void {

    this.startDate = this.data.start;
    this.endDate = this.data.end;

    console.log("Start:", this.startDate);
    console.log("End:", this.endDate);

    // ✅ Get all Sundays
    this.sundayDates = this.getSundaysBetweenDates(this.startDate, this.endDate);

    console.log("Sunday Dates:", this.sundayDates);
    // this.service.getSundayData(this.startDate, this.endDate).subscribe(res => {

    //   // ✅ Ensure all Sundays exist in each row
    //   this.yourData = res.map(item => {
    //     this.sundayDates.forEach(date => {
    //       if (!item[date]) {
    //         item[date] = 0;
    //       }
    //     });
    //     return item;
    //   });

    //   console.log("Final Data:", this.yourData);
    // });

    this.loadData();

    this.yourData.sort((a, b) => {
      return (a.thikan || '').localeCompare(b.thikan || '', 'mr');
    });

  }

  getSundaysBetweenDates(start: string, end: string): string[] {
    const result: string[] = [];

    let current = new Date(start + 'T00:00:00');
    const last = new Date(end + 'T00:00:00');

    // Move to first Sunday
    while (current.getDay() !== 0) {
      current.setDate(current.getDate() + 1);
    }

    while (current <= last) {
      result.push(formatDate(current, 'dd/MM/yyyy', 'en-IN'));
      current.setDate(current.getDate() + 7);
    }

    return result;
  }

  getMonthYearInMarathi(start: any, end: any): string {
  if (!start || !end) return '';

  const marathiMonths = [
    'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून',
    'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
  ];

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startMonth = marathiMonths[startDate.getMonth()];
  const startYear = startDate.getFullYear();

  const endMonth = marathiMonths[endDate.getMonth()];
  const endYear = endDate.getFullYear();

  // ✅ Same month
  if (startMonth === endMonth && startYear === endYear) {
    return `${startMonth} ${startYear}`;
  }

  // ✅ Different month
  return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
}

  // loadData() {
  //   const request = {
  //     start: this.data.start,
  //     end: this.data.end
  //   };

  //   this.service.getVatnavalData(request).subscribe(
  //     (res) => {
  //       console.log("API Response:", res);
  //       this.yourData = res;
  //     },
  //     (err) => {
  //       console.error("API Error:", err);
  //     }
  //   );
  // }

  loadData() {
    const request = {
      start: this.data.start,
      end: this.data.end
    };

    this.service.getVatnavalData(request).subscribe(
      (res) => {
        console.log("API Response:", res);

        // ✅ FILTER: remove zero records
        this.yourData = (res || []).filter(item => {
          return this.toInt1(item.total_Ank) > 0 || this.toInt1(item.previous_Vatnaval) > 0;
        });

          // ✅ NEW: if rate is 0 → keep previous rate (from backend or cache)
      // this.yourData.forEach(item => {
      //   if (!item.vatnavl_Rate || item.vatnavl_Rate === 0) {
      //     item.vatnavl_Rate = item.vatnavl_Rate || 0; 
      //     // backend will already send last rate after PHP change
      //   }
      // });

      this.yourData.forEach(item => {
  if (!item.vatnavl_Rate || item.vatnavl_Rate === 0) {
    item.vatnavl_Rate = item.vatnavl_Rate ?? 0;
  }
});

        // ✅ SORT: district alphabetical
        this.yourData.sort((a, b) => {
          return (a.thikan || '').localeCompare(b.thikan || '');
        });

        console.log("Filtered & Sorted Data:", this.yourData);
      },
      (err) => {
        console.error("API Error:", err);
      }
    );
  }


  sumOfTotal: any
  totalVatnaval: number = 0
  total_ank: number = 0

  calculateTotal() {

    // ✅ Reset all totals FIRST
    this.sumOfTotal = 0;
    this.totalVatnaval = 0;
    this.total_ank = 0;

    const list = this.yourData || [];

    list.forEach(element => {

      const rate = this.toInt(element.vatnavl_Rate);
      const ank = this.toInt(element.total_Ank);

      // ✅ Individual totals
      this.totalVatnaval += rate;
      this.total_ank += ank;

      // ✅ Main calculation (rate × ank)
      this.sumOfTotal += (rate * ank);

    });
  }

  toInt(no: any): number {
    const val = Number(no);
    return isNaN(val) ? 0 : val;
  }

  // Footer All Columns Total 
  // ✅ Sunday column total
  getSundayTotal(date: string): number {
    let total = 0;

    (this.yourData || []).forEach(item => {
      total += this.toInt1(item[date]);
    });

    return total;
  }


  // ✅ Column totals
  getTotalAnk(): number {
    return (this.yourData || []).reduce((sum, item) => {
      return sum + this.toInt1(item.total_Ank);
    }, 0);
  }

  getVatnavalTotal(): number {
    return (this.yourData || []).reduce((sum, item) => {
      return sum + this.toInt1(item.vatnaval_Total);
    }, 0);
  }

  // calculateRow(item: any) {

  //   const ank = this.toInt1(item.total_Ank);
  //   const rate = this.toInt1(item.vatnavl_Rate);
  //   const previous = this.toInt1(item.previous_Vatnaval);
  //   const accountPayment = this.toInt1(item.exp_amt);

  //   // ✅ Row-wise calculation
  //   item.vatnaval_Total = ank * rate;

  //   // ✅ Optional extra fields
  //   item.all_Vatnaval_Amount = item.vatnaval_Total + previous;
  //   item.remaining_Vatnaval_Amount = item.all_Vatnaval_Amount - accountPayment;

  // }

  getPreviousTotal(): number {
    return (this.yourData || []).reduce((sum, item) => {
      return sum + this.toInt1(item.previous_Vatnaval);
    }, 0);
  }

  // getAllVatnavalTotal(): number {
  //   return (this.yourData || []).reduce((sum, item) => {

  //     const ank = this.toInt1(item.total_Ank);
  //     const rate = this.toInt1(item.vatnavl_Rate);
  //     const previous = this.toInt1(item.previous_Vatnaval);

  //     const current = ank * rate;

  //     return sum + (current + previous);

  //   }, 0);
  // }

 getAccountPaymentAmount(): number {
  return (this.yourData || []).reduce((sum, item) => {
    return sum + this.toInt1(item.exp_amt);
  }, 0);
}


 getAllRemainingTotal(): number {
  return Math.abs(this.getAccountPaymentAmount() - this.getAllVatnavalTotal());
}

 getAllPastDueAmount(): number {
  return (this.yourData || []).reduce((sum, item) => {
    return sum + this.toInt1(item.description);
  }, 0);
}

  // helper
  // toInt1(val: any): number {
  //   const num = Number(val);
  //   return isNaN(num) ? 0 : num;
  // }

  toInt1(val: any): number {
    if (val === undefined || val === null || val === '') return 0;
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }

  // saveSubscriptionBarcodesDataEntry() {

  //   const payload = (this.yourData || []).map(item => {

  //     // ✅ Map Sundays → Week1 to Week5
  //     const weeks = this.sundayDates;

  //     return {
  //       issue_Seller_Name: item.name || '',
  //       place: item.thikan || '',
  //       vatnaval_Rate: this.toInt1(item.vatnavl_Rate),

  //       issue_Date_Week1: item[weeks[0]] || 0,
  //       issue_Date_Week2: item[weeks[1]] || 0,
  //       issue_Date_Week3: item[weeks[2]] || 0,
  //       issue_Date_Week4: item[weeks[3]] || 0,
  //       issue_Date_Week5: item[weeks[4]] || 0,

  //       total_Ank: this.toInt1(item.total_Ank),
  //       vatnaval_Total: this.toInt1(item.vatnaval_Total),
  //       previous_Vatnaval: this.toInt1(item.previous_Vatnaval),
  //       all_Vatnaval_Amount: this.toInt1(item.all_Vatnaval_Amount),

  //       payment_Type: item.payment_Type || '',
  //       description: item.description || '',
  //       remaining_Account_Amount: this.toInt1(item.remaining_Vatnaval_Amount)
  //     };
  //   });

  //   console.log("Final Payload:", payload);

  //   this.service.saveVatnavalData({ data: payload }).subscribe(
  //     (res) => {
  //       alert('All Records Saved successfully!');
  //     },
  //     (err) => {
  //       console.error(err);
  //     }
  //   );
  // }

saveSubscriptionBarcodesDataEntry() {

  const payload = (this.yourData || []).map(item => {

    const weeks = this.sundayDates;

    return {
      issue_Seller_Name: item.name || '',
      place: item.thikan || '',
      vatnaval_Rate: this.toInt1(item.vatnavl_Rate),

      // ✅ SEND DATE + COUNT SEPARATELY
      week1_date: weeks[0] || null,
      week1_count: this.toInt1(item[weeks[0]]),

      week2_date: weeks[1] || null,
      week2_count: this.toInt1(item[weeks[1]]),

      week3_date: weeks[2] || null,
      week3_count: this.toInt1(item[weeks[2]]),

      week4_date: weeks[3] || null,
      week4_count: this.toInt1(item[weeks[3]]),

      week5_date: weeks[4] || null,
      week5_count: this.toInt1(item[weeks[4]]),

      total_Ank: this.toInt1(item.total_Ank),
      vatnaval_Total: this.toInt1(item.vatnaval_Total),
      previous_Vatnaval: this.toInt1(item.previous_Vatnaval),
      all_Vatnaval_Amount: this.toInt1(item.all_Vatnaval_Amount),

      payment_Type: item.exp_amt || '',
       account_Sign: item.d_voucher_date || '',
      description: item.description || '',
      description1: item.description1 || '',

      remaining_Account_Amount: this.toInt1(item.remaining_Vatnaval_Amount)
    };
  });

  this.service.saveVatnavalData({ data: payload }).subscribe(
    (res) => {
      console.log(res);
      alert('All Records Saved successfully!');
    },
    (err) => console.error(err)
  );
}


  exportExcel(fileName: string): void {

  const element = document.getElementById('print-section');

  if (!element) return;

  // ✅ CLONE TABLE (original disturb होणार नाही)
  const clone = element.cloneNode(true) as HTMLElement;

  // ✅ FIND ALL INPUTS
  const inputs = clone.querySelectorAll('input');

  inputs.forEach((input: any) => {

    const value = input.value || 0;

    // ✅ CREATE TEXT NODE
    const textNode = document.createTextNode(value);

    // ✅ REPLACE INPUT WITH VALUE
    input.parentNode.replaceChild(textNode, input);
  });

  // ✅ NOW EXPORT CLEAN TABLE
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(clone);

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, fileName + '.xlsx');
}


 show = false
// New Correct Code
// printPage() {
//   this.show = true;

//   setTimeout(() => {

//     const element = document.getElementById('print-section');

//     if (!element) {
//       console.error("Print section not found!");
//       return;
//     }

//     let htmlContent = element.innerHTML;

//     // ✅ CLONE FOOTER INTO HEADER (REPEAT ON EVERY PAGE)
//     htmlContent = htmlContent.replace(
//       /<tfoot>([\s\S]*?)<\/tfoot>/gi,
//       (match, footerContent) => {
//         return `
//           <thead class="repeat-footer">
//             ${footerContent}
//           </thead>
//           ${match}
//         `;
//       }
//     );

//     const printWindow = window.open('', '_blank');

//     if (!printWindow) {
//       console.error("Failed to open print window.");
//       return;
//     }

//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//       <head>
//         <title>Print Report</title>

//         <style>

//           @page { 
//             size: A4 landscape;
//             margin: 5mm;
//           }

//           body {
//             margin: 0;
//             font-family: Arial, sans-serif;
//             font-size: 12px;
//           }

//           .row {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }

//           th {
//             border: 1px solid #000;
//             padding: 4px;
//             text-align: center;
//             font-size: 12px;
//             white-space: normal;
//             word-break: break-word;
//           }

//           td {
//             border: 1px solid #000;
//             padding: 3px;
//             font-size: 12px;
//             white-space: nowrap;
//           }

//           thead th {
//             background: #f2f2f2;
//             font-weight: bold;
//           }

//           /* ✅ Repeat header (now includes totals) */
//           thead { display: table-header-group; }

//           /* ❌ Disable default footer behavior */
//           tfoot { display: table-row-group; }

//           @media print {
//             body { zoom: 0.75; }

//             thead { display: table-header-group; }

//             tr { page-break-inside: avoid; }

//             .noPrint { display: none !important; }
//           }

//         </style>

//       </head>

//       <body>

//         ${htmlContent}

//         <script>
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               window.close();
//             }, 300);
//           };
//         <\/script>

//       </body>
//       </html>
//     `);

//     printWindow.document.close();

//     this.show = false;

//   }, 300);
// }

// Old Correct Method
// printPage() {
//   this.show = true;

//   setTimeout(() => {   // ✅ IMPORTANT (Angular render wait)

//     const element = document.getElementById('print-section');

//     if (!element) {
//       console.error("Print section not found!");
//       return;
//     }

//     // ✅ USE innerHTML (Angular rendered values)
//     let htmlContent = element.innerHTML;

//     const printWindow = window.open('', '_blank');

//     if (!printWindow) {
//       console.error("Failed to open print window.");
//       return;
//     }

//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//       <head>
//         <title>Print Report</title>

//         <style>

//           @page { 
//             size: A4 landscape;
//             margin: 5mm;
//           }

//           body {
//             margin: 0;
//             font-family: Arial, sans-serif;
//             font-size: 12px;
//           }

//           .row {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }

//           th {
//             border: 1px solid #000;
//             padding: 4px;
//             text-align: center;
//             font-size: 12px;
//             white-space: normal;
//             word-break: break-word;
//           }

//           td {
//             border: 1px solid #000;
//             padding: 3px;
          
//             font-size: 12px;
//             white-space: nowrap;
//           }

//           thead th {
//             background: #f2f2f2;
//             font-weight: bold;
//           }

//           @media print {
//             body { zoom: 0.75; }

//             thead { display: table-header-group; }
//             tfoot { display: table-footer-group; }

//             tr { page-break-inside: avoid; }

//             .noPrint { display: none !important; }
//           }

//         </style>

//       </head>

//       <body>

//         ${htmlContent}

//         <script>
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               window.close();
//             }, 300);
//           };
//         <\/script>

//       </body>
//       </html>
//     `);

//     printWindow.document.close();

//     this.show = false; // ✅ reset after print

//   }, 300); // ⏳ wait for UI update
// }

// Not Remove शेरा Column only 
// printPage() {
//   this.show = true;

//   setTimeout(() => {

//     const element = document.getElementById('print-section');

//     if (!element) {
//       console.error("Print section not found!");
//       return;
//     }

//     let htmlContent = element.innerHTML;

//     // ✅ TEMP DOM (for safe manipulation)
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = htmlContent;

//     const tables = tempDiv.querySelectorAll('table');

//     tables.forEach(table => {

//       let sheracolIndex = -1;

//       // ✅ FIND "शेरा" COLUMN INDEX (ONLY ONCE)
//       const headerRow = table.querySelector('tr');
//       if (headerRow) {
//         const headerCells = headerRow.querySelectorAll('th, td');
//         headerCells.forEach((cell, index) => {
//           if (cell.textContent?.trim() === 'शेरा') {
//             sheracolIndex = index;
//           }
//         });
//       }

//       // ✅ REMOVE "शेरा" COLUMN FROM ALL ROWS
//       if (sheracolIndex !== -1) {
//         table.querySelectorAll('tr').forEach(row => {
//           const cells = row.querySelectorAll('th, td');
//           if (cells[sheracolIndex]) {
//             cells[sheracolIndex].remove();
//           }
//         });
//       }

//     });

//     // ✅ REMOVE ROW "हस्ते वाटणावळ - एप्रिल 2026"
//     tempDiv.querySelectorAll('tr').forEach(row => {
//       if (row.textContent?.includes('हस्ते वाटणावळ - एप्रिल 2026')) {
//         row.remove();
//       }
//     });

//     // ✅ CLONE FOOTER INTO HEADER (REPEAT ON EVERY PAGE)
//     let updatedHTML = tempDiv.innerHTML.replace(
//       /<tfoot>([\s\S]*?)<\/tfoot>/gi,
//       (match, footerContent) => {
//         return `
//           <thead class="repeat-footer">
//             ${footerContent}
//           </thead>
//           ${match}
//         `;
//       }
//     );

//     const printWindow = window.open('', '_blank');

//     if (!printWindow) {
//       console.error("Failed to open print window.");
//       return;
//     }

//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//       <head>
//         <title>Print Report</title>

//         <style>

//           @page { 
//             size: A4 landscape;
//             margin: 5mm;
//           }

//           body {
//             margin: 0;
//             font-family: Arial, sans-serif;
//             font-size: 12px;
//           }

//           .row {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }

//           th {
//             border: 1px solid #000;
//             padding: 4px;
//             text-align: center;
//             font-size: 12px;
//             white-space: normal;
//             word-break: break-word;
//           }

//           td {
//             border: 1px solid #000;
//             padding: 3px;
//             font-size: 12px;
//             white-space: nowrap;
//           }

//           thead th {
//             background: #f2f2f2;
//             font-weight: bold;
//           }

//           thead { display: table-header-group; }
//           tfoot { display: table-row-group; }

//           @media print {
//             body { zoom: 0.75; }
//             tr { page-break-inside: avoid; }
//             .noPrint { display: none !important; }
//           }

//         </style>

//       </head>

//       <body>

//         ${updatedHTML}

//         <script>
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               window.close();
//             }, 300);
//           };
//         <\/script>

//       </body>
//       </html>
//     `);

//     printWindow.document.close();

//     this.show = false;

//   }, 300);
// }

printPage() {
  this.show = true;

  setTimeout(() => {

    const element = document.getElementById('print-section');

    if (!element) {
      console.error("Print section not found!");
      return;
    }

    let htmlContent = element.innerHTML;

    // ✅ TEMP DOM (for safe manipulation)
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    const tables = tempDiv.querySelectorAll('table');

    tables.forEach(table => {

      let sheracolIndex = -1;

      // ✅ FIND "शेरा" COLUMN INDEX (ONLY ONCE)
      const headerRow = table.querySelector('tr');
      if (headerRow) {
        const headerCells = headerRow.querySelectorAll('th, td');
        headerCells.forEach((cell, index) => {
          if (cell.textContent?.trim() === 'शेरा') {
            sheracolIndex = index;
          }
        });
      }

      // ✅ REMOVE "शेरा" COLUMN FROM ALL ROWS
      if (sheracolIndex !== -1) {
        table.querySelectorAll('tr').forEach(row => {
          const cells = row.querySelectorAll('th, td');
          if (cells[sheracolIndex]) {
            cells[sheracolIndex].remove();
          }
        });
      }

      // ✅ ALIGN: STRING = LEFT, AMOUNT/NUMBER = RIGHT
      table.querySelectorAll('tbody tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, colIndex) => {
          const rawText = cell.textContent?.trim() || '';

          // ✅ Serial number column → center
          if (colIndex === 0) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          // ✅ Name & Place columns → left align (col 1 and 2)
          if (colIndex === 1 || colIndex === 2) {
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
            return;
          }

          // ✅ Date column (अकाऊंट दिनांक) → center
          // Detect dd-MM-yyyy format
          const isDate = /^\d{2}-\d{2}-\d{4}$/.test(rawText);
          if (isDate) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          // ✅ Number/Amount → right align
          const isNumeric = rawText === '' || rawText === '0' || (!isNaN(Number(rawText)) && rawText !== '');
          if (isNumeric) {
            (cell as HTMLElement).style.textAlign = 'right';
            (cell as HTMLElement).style.paddingRight = '5px';
          } else {
            // ✅ Any other text → left align
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
          }
        });
      });

      // ✅ FOOTER ROW ALIGNMENT
      table.querySelectorAll('tfoot tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, colIndex) => {
          const rawText = cell.textContent?.trim() || '';

          if (colIndex === 0) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          const isNumeric = rawText === '' || rawText === '0' || (!isNaN(Number(rawText)) && rawText !== '');
          if (isNumeric) {
            (cell as HTMLElement).style.textAlign = 'right';
            (cell as HTMLElement).style.paddingRight = '5px';
          } else {
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
          }
        });
      });

    });

    // ✅ REMOVE ROW "हस्ते वाटणावळ - एप्रिल 2026"
    tempDiv.querySelectorAll('tr').forEach(row => {
      if (row.textContent?.includes('हस्ते वाटणावळ')) {
        row.remove();
      }
    });

    // ✅ CLONE FOOTER INTO HEADER (REPEAT ON EVERY PAGE)
    let updatedHTML = tempDiv.innerHTML.replace(
      /<tfoot>([\s\S]*?)<\/tfoot>/gi,
      (match, footerContent) => {
        return `
          <thead class="repeat-footer">
            ${footerContent}
          </thead>
          ${match}
        `;
      }
    );

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      console.error("Failed to open print window.");
      return;
    }

    printWindow.document.open();
    printWindow.document.write(`
      <html>
      <head>
        <title>Print Report</title>

        <style>

          @page { 
            size: A4 landscape;
            margin: 5mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
          }

          .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th {
            border: 1px solid #000;
            padding: 4px;
            text-align: center;
            font-size: 12px;
            white-space: normal;
            word-break: break-word;
          }

          td {
            border: 1px solid #000;
            padding: 3px;
            font-size: 12px;
            white-space: nowrap;
          }

          thead th {
            background: #f2f2f2;
            font-weight: bold;
          }

          thead { display: table-header-group; }
          tfoot { display: table-row-group; }

          @media print {
            body { zoom: 0.75; }
            tr { page-break-inside: avoid; }
            .noPrint { display: none !important; }
          }

        </style>

      </head>

      <body>

        ${updatedHTML}

        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 300);
          };
        <\/script>

      </body>
      </html>
    `);

    printWindow.document.close();

    this.show = false;

  }, 300);
}


calculateRow(item: any) {
  const ank = this.toInt1(item.total_Ank);
  const rate = this.toInt1(item.vatnavl_Rate);
  const previous = this.toInt1(item.previous_Vatnaval);
  const accountPayment = this.toInt1(item.exp_amt);
  const shera = this.toInt1(item.description); // ✅ ADD THIS
  // const shera1 = this.toInt1(item.description1); // ✅ ADD THIS


  item.vatnaval_Total = ank * rate;

  item.all_Vatnaval_Amount = item.vatnaval_Total + previous + shera; // ✅ CHANGED

  item.remaining_Vatnaval_Amount = item.all_Vatnaval_Amount - accountPayment;
}

getAllVatnavalTotal(): number {
  return (this.yourData || []).reduce((sum, item) => {
    const ank = this.toInt1(item.total_Ank);
    const rate = this.toInt1(item.vatnavl_Rate);
    const previous = this.toInt1(item.previous_Vatnaval);
    const shera = this.toInt1(item.description); // ✅ ADD THIS

    const current = ank * rate;

    return sum + (current + previous + shera); // ✅ CHANGED
  }, 0);
}

}
